module.exports = __webpack_public_path__ + "img/logo.98cc78ba.png";